export enum BlockedBy {
  FailedPaymentRule = 'Failed payment rule',
  AdminAction = 'Admin action',
}

export enum BlacklistEventType {
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  REACTIVATE = 'REACTIVATE',
}

export type BlacklistEmail = {
  email: string;
  reason: string;
  date: string;
  blockedBy?: BlockedBy;
};
